import ChatSDK from  'test-iso-chat-sdk'

export const postReaction = async (reactionType, messageId, conversationId) => {
    const response = await ChatSDK.initializeInstance().message.postReaction({conversationId: conversationId, messageId: messageId, reactionType: reactionType});
    return response
};

export const deleteReaction = async (conversationId, messageId, reactionType) => {
    const response = await ChatSDK.initializeInstance().message.deleteReactionType({conversationId: conversationId, messageId: messageId}, reactionType);
    return response
}

export const getReactions = async (conversationId, messageId, reactionType) => {
    const response = await ChatSDK.initializeInstance().message.getMessageReactionType({conversationId: conversationId, messageId: messageId}, reactionType);
    return response
}